import { MARQUEE_ITEMS } from '@/content';

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden border-y border-[#E4E6EB] bg-white py-4">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-display text-xs font-bold uppercase tracking-[0.34em] text-[#404145]">
            {item}
            <span className="inline-block h-3.5 w-3.5 rounded-full border-[3px] border-[#C92F4B]" />
          </span>
        ))}
      </div>
    </div>
  );
}
